module.exports = __webpack_public_path__ + "static/media/products_bg@3x.e635b439.webp";